/**
 * Created by afuhr on 06.04.2017.
 */
export function isUnauthorizedError(err: Error): err is UnauthorizedError {
  return err instanceof UnauthorizedError;
}
export class UnauthorizedError extends Error {
  message: string;

  constructor(message: string, public response?: any) {
    super(message);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/exceptions/unauthorized-error.ts